import { memo, useCallback } from "react";
import { useModals } from "@mantine/modals";
import { useParams } from "react-router-dom";
import ActionCard from "src/components/ActionCard";
import { GetAgreementQuery, GetPackageQuery } from "src/generated/graphql";
import InitialChargeDetail from "../InitialChargeDetail";
import { Sx, Text } from "@mantine/core";
import { HeightCard, CardRadius } from "src/utils/constants";

interface IInitialCharges {
  initialCharges:
    | NonNullable<GetAgreementQuery["agreementOne"]>["initialCharges"]
    | NonNullable<GetPackageQuery["packageOne"]>["initialCharges"];
  title: string;
  sx?: Sx | (Sx | undefined)[] | undefined;
  disabled?: boolean;
  isAllowWrite: boolean;
  isEditable?: boolean;
}

function InitialChargeList({
  initialCharges,
  title,
  sx = {},
  disabled,
  isAllowWrite,
  isEditable,
}: IInitialCharges) {
  const modals = useModals();
  const { pkgId } = useParams<{ pkgId: string }>();
  const { agreementId } = useParams<{ agreementId: string }>();

  const handleModal = useCallback(
    (initialCharge = null) => {
      (pkgId || agreementId) &&
        modals.openModal({
          closeOnClickOutside: false,
          title: `${initialCharge ? "Update" : "Create"} Initial Charge`,
          children: (
            <InitialChargeDetail
              formData={initialCharge}
              isModal={true}
              pkgId={pkgId}
              agreementId={agreementId}
              isAllowWrite={isAllowWrite}
            />
          ),
        });
    },
    [pkgId, agreementId, isAllowWrite]
  );
  return (
    <ActionCard
      sx={sx}
      title={title}
      mb={"sm"}
      handleModal={
        disabled || !isAllowWrite
          ? undefined
          : () => {
              if (!isEditable) {
                modals.openModal({
                  closeOnClickOutside: true,
                  title: "Error!",
                  children: (
                    <Text size="sm">
                      This is an org-level package. You do not have permission
                      to edit this package.
                    </Text>
                  ),
                });
                return;
              }
              handleModal();
            }
      }
      height={agreementId ? HeightCard.xs : HeightCard.lg}
      radius={CardRadius.xs}
      size="md"
    >
      {initialCharges?.map((e) => (
        <InitialChargeDetail
          key={e.id}
          formData={e}
          handleModal={handleModal}
          pkgId={pkgId}
          agreementId={agreementId}
          disabled={disabled}
          isAllowWrite={isAllowWrite && isEditable!}
        />
      ))}
    </ActionCard>
  );
}

export default memo(InitialChargeList);
